export const DELAY_BETWEEN_MESSAGES = 600;
export const DAY = 1000 * 60 * 60 * 24;

export enum ACTIONS {
  // chat
  CHAT_ADD_ITEM = 'CHAT_ADD_ITEM',
  CHAT_CHANGE_MESSAGE = 'CHAT_CHANGE_MESSAGE',
  CHAT_RESET = 'CHAT_RESET',
  CHAT_CHANGE_MODE = 'CHAT_CHANGE_MODE',
  CHAT_TOGGLE_MUTE = 'CHAT_TOGGLE_MUTE',
  CHAT_TOGGLE_LOCK = 'CHAT_TOGGLE_LOCK',
  CHAT_ADD_UNDELIVERED = 'CHAT_ADD_UNDELIVERED',
  CHAT_REMOVE_UNDELIVERED = 'CHAT_REMOVE_UNDELIVERED',
  CHAT_UPDATE_SESSION = 'CHAT_UPDATE_SESSION',
  INCREASE_UNREAD_COUNT = 'INCREASE_UNREAD_COUNT',
  RESET_UNREAD_COUNT = 'RESET_UNREAD_COUNT',
  // field
  FIELD_UPDATE_CHATBOT = 'FIELD_UPDATE_CHATBOT',
  FIELD_UPDATE_LIVE_CHAT = 'FIELD_UPDATE_LIVE_CHAT',
  FIELD_CHANGE_VALUE = 'FIELD_CHANGE_VALUE',
  SEND_MESSAGE = 'SEND_MESSAGE',
  // header
  ENABLE_BUTTON = 'ENABLE_BUTTON',
  HIDE_ALERT = 'HIDE_ALERT',
  JOINED_AGENT = 'JOINED_AGENT',
  LEFT_AGENT = 'LEFT_AGENT',
  // user
  SET_USER = 'SET_USER',
  // attaches
  LOAD_START = 'LOAD_START',
  LOAD_SUCCESS = 'LOAD_SUCCESS',
  LOAD_FAIL = 'LOAD_FAIL',
  CLOSE_ERROR = 'CLOSE_ERROR',
  REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT',
  // modal
  MODAL_OPEN = 'MODAL_OPEN',
  MODAL_CLOSE = 'MODAL_CLOSE',
  // meta
  META_UPDATE_PAGE_URL = 'META_UPDATE_PAGE_URL',
  META_UPDATE_INTENT_ID = 'META_UPDATE_INTENT_ID',
  META_UPDATE_ORIG_PARAMS = 'META_UPDATE_ORIG_PARAMS',
  META_UPDATE_DEALER_OFFER_PARAMS = 'META_UPDATE_DEALER_OFFER_PARAMS',
  // inputs focus
  INPUTS_FOCUS_SEARCH = 'INPUTS_FOCUS_SEARCH',
  INPUTS_FOCUS_CHATBOT = 'INPUTS_FOCUS_CHATBOT',
  // URL session sync action
  SESSION_URL_CHANGED = 'SESSION_URL_CHANGED',
  // root actions
  RESET_CHATBOT_STATE = 'RESET_CHATBOT_STATE',
}

export enum ROLE {
  BOT,
  USER,
}

export enum MESSAGES {
  ARTICLE = ':ARTICLE',
  BOT_MESSAGE = ':BOT_MESSAGE',
  BOT_TYPING = ':BOT_TYPING',
  USER_MESSAGE = ':USER_MESSAGE',
  BUTTONS = ':BUTTONS',
  BUTTONS_VERTICAL = ':BUTTONS_VERTICAL',
  PHONE = ':PHONE_SELECTOR',
  VIDEO = ':VIDEO',
  IMAGE = ':IMAGE',
  // selectors
  CATEGORY = ':CATEGORY',
  SITE_SELECTOR = ':SITE_SELECTOR',
  DOMAIN_SELECTOR = ':DOMAIN_SELECTOR',
  PLAN_SELECTOR = ':PLAN_SELECTOR',
  ARTICLE_SELECTOR = ':ARTICLE_SELECTOR',
  INVOICE_SELECTOR = ':INVOICE_SELECTOR',
  SUGGESTION_SELECTOR = ':SUGGESTION_SELECTOR',
  TICKET_SELECTOR = ':TICKET_SELECTOR',
  LOGIN_SELECTOR = ':LOGIN_SELECTOR',
  // It's a types for messages in chat
  CHANGE_MODE = ':CHANGE_MODE',
  AGENT_STATUS = ':AGENT_STATUS',
  AGENT_MESSAGE = ':AGENT_MESSAGE',
}

export enum SELECTOR_TYPE_RPC {
  ':PHONE_SELECTOR' = 'PHONE_SELECTOR',
  ':ARTICLE_SELECTOR' = 'ARTICLE_SELECTOR',
  ':INVOICE_SELECTOR' = 'INVOICE_SELECTOR',
  ':DOMAIN_SELECTOR' = 'DOMAIN_SELECTOR',
  ':TICKET_SELECTOR' = 'TICKET_SELECTOR',
  ':PLAN_SELECTOR' = 'PLAN_SELECTOR',
  ':SITE_SELECTOR' = 'SITE_SELECTOR',
  ':SUGGESTION_SELECTOR' = 'SUGGESTION_SELECTOR',
}

export enum SELECTOR_TYPE_TO_ITEM_NAME {
  ':PHONE_SELECTOR' = 'phoneSelector',
  ':ARTICLE_SELECTOR' = 'articleSelector',
  ':INVOICE_SELECTOR' = 'invoiceSelector',
  ':DOMAIN_SELECTOR' = 'domainSelector',
  ':TICKET_SELECTOR' = 'ticketSelector',
  ':PLAN_SELECTOR' = 'planSelector',
  ':SITE_SELECTOR' = 'siteSelector',
  ':SUGGESTION_SELECTOR' = 'suggestionSelector',
}

// It's a types that coming from duplexer
export enum EVENTS_LIVE_CHAT {
  AGENT_REPLIED = 'AGENT_REPLIED',
  AGENT_JOINED = 'AGENT_JOINED',
  AGENT_LEFT = 'AGENT_LEFT',
}

export enum DuplexerEvent {
  URL_CHANGED = 'URL_CHANGED',
}

export enum INTERNAL_MESSAGE {
  START = ':START',
  REDIRECT = ':REDIRECT',
}

export enum WIXANSWERS {
  HEIGHT = 'WIXANSWERS:HEIGHT',
  LINK_CLICKED = 'WIXANSWERS:LINK_CLICKED',
}

export enum UI {
  SELECTOR_CLICKED = 'CHATBOT_UI:SELECTOR_CLICKED',
  CATEGORY_CLICKED = 'CHATBOT_UI:CATEGORY_CLICKED',
  BUTTON_CLICKED = 'CHATBOT_UI:BUTTON_CLICKED',
  CHANGE = 'CHATBOT_UI:CHANGE',
  SEND_MESSAGE = 'CHATBOT_UI:SEND_MESSAGE',
  MODAL_SITE_CLOSE = 'CHATBOT_UI:MODAL_SITE_CLOSE',
  CLOSE_LIVE_CHAT = 'CHATBOT_UI:CLOSE_LIVE_CHAT',
  CANT_LOGIN_CLICKED = 'CHATBOT_UI:CANT_LOGIN_CLICKED',
}

export enum MODAL {
  SITE = ':MODAL_SITE',
}

export enum MODE {
  chatbot = 'chatbot',
  live_chat = 'live-chat',
}

export enum ROUTES {
  MAIN = '/',
  WIDGET = '/widget',
  WIDGET_ALL = '/widget/*',
  POST_LOGIN = '/post-login',
  USER_ACTION = '/api/user-action',
  ARTICLES_SEARCH = '/api/search',
  START_CHAT = '/api/start-chat',
  CONTEXT = '/api/context',
  HELP_CENTER_SESSION = '/api/help-center-session',
  SESSIONS = '/api/sessions',
  RESTART_CHAT = '/api/restart-chat',
  GET_LIVE_CHAT_MESSAGES = '/api/messages',
}
